import { defineMessagesSimple } from '@atlassiansox/bxpkit-core';

export const messages = defineMessagesSimple('WacSignupForm.FirstImpressions', {
  noCreditCardRequiredFooter: `No credit card required`,
  firstImpressionsEula:
    "<p>By signing up, you agree to the Atlassian <a href='https://www.atlassian.com/legal/cloud-terms-of-service'>Cloud Terms of Service</a> and <a href='https://www.atlassian.com/legal/privacy-policy'>Privacy Policy.</a></p>",
  firstImpressionsRecaptcha:
    'This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.',
  firstImpressionsLoggedOutFormHeader: 'Get Started',
  firstImpressionsLoggedOutFormSubHeader: 'Free for up to 10 users',
  firstImpressionsLoggedInFormHeader: 'Welcome back, {userName}',
  inputLabelWorkEmail: 'Work email',
  inputLabelWorkEmailError: 'Invalid email address',
  inputLabelFullName: 'Full name',
  inputLabelSiteName: 'Claim your site',
  submitButtonLabel: 'Agree',
  socialSignUpButtonContinueWithGoogle: 'Continue with Google',
  socialSignUpButtonSignUpWithEmail: 'Sign up with email',
  socialSignUpDividerLabel: 'OR',
  inputLabelFullNameLengthError: 'Must be 255 characters or less',
  inputLabelRequired: 'Required',
  firstImpressionsLoggedOutFormSubmitError:
    'Something went wrong, please try again.',
  firstImpressionsSamlRequired:
    'You must use single sign-on to access your account and continue signing up for your product. <a href="{loginUrl}">Login to continue</a>',
  firstImpressionsSsoCheckError:
    'There was an unexpected error validating your email. Please check your network settings.',
  userHasPaidSites:
    'Looks like you already have a Standard/Premium Atlassian product. Unfortunately the discount only applies for new customers.',
  goToMyProducts: 'Go to my products'
});
